import { SyncService } from '../../sync.service';
import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ListItem } from 'carbon-components-angular';
import { HttpService } from '../../http.service';
import { saveAs } from 'file-saver';
import { Subscription } from 'rxjs';

@Component({
	selector: 'files',
	templateUrl: './files.component.html',
	styleUrls: ['./files.component.css'],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger('fadeIn', [
			transition(':enter', [
				style({ opacity: 0}),
				animate('125ms ease-in', style({ opacity: 1 }))
			]),
			transition(':leave', [
				animate('125ms ease-out', style({ opacity: 0}))
			])
		]),
		trigger('fadeInUp', [
			transition(':enter', [
				style({ opacity: 0, transform: 'translateY(-2px)' }),
				animate('125ms ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
			]),
			transition(':leave', [
				animate('125ms ease-out', style({ opacity: 0, transform: 'translateY(2px)' }))
			])
		])
	]
})
export class FilesComponent implements OnInit, OnDestroy {

	deals: any[] = [];
	displayFiles: any[] = [];
	currentFileData: any = {};
	currentFileTypes: any = []
	validateUrl = environment.aggregateUrl;

	hoveringOverItem = '';
	currentDeal = '';
	userData: any = {};
	email = '';
	exportUrl = environment.exportUrl;
	editFileModalOpen = false;

	@ViewChild('cdsModalContent') cdsModalContent!: ElementRef;
	@ViewChild('datePicker') datePicker!: ElementRef;
	@ViewChild('comboBox') comboBox!: ElementRef;

	fileTypeItems = [
		{
			'content': 'Annual or Quarterly Report',
			'selected': false
		},
		{
			'content': 'Audit or Financial Statement',
			'selected': false
		},
		{
			'content': 'Capital Account Statement',
			'selected': false
		},
		{
			'content': 'Fund and Portfolio Assets Performance',
			'selected': false
		},
		{
			'content': 'Limited Partnership Agreement',
			'selected': false
		},
		{
			'content': 'Distribution Notice',
			'selected': false
		},
		{
			'content': 'Other',
			'selected': false
		}
	]
	fileNameInvalid: any;
	fileNameInvalidText = 'File name is required';
	fileName = '';
	fileReferenceDate = '';
	fileReferenceDateObject: any = [new Date()];
	subscription: Subscription | undefined;

	setTargetMinWidth(): void {
		const modalWidth = this.cdsModalContent.nativeElement.offsetWidth;
		let datePickerInput = this.datePicker.nativeElement.querySelector('.cds--date-picker__input');
		let cdsComboBox = this.comboBox.nativeElement.querySelector('.cds--list-box__field');
		let listBoxMenuItems = this.comboBox.nativeElement.querySelectorAll('.cds--list-box__menu-item');
		listBoxMenuItems.forEach((listBoxMenuItem: any) => {
			try {
				this.renderer.setStyle(listBoxMenuItem, 'min-width', (modalWidth - 32).toString() + 'px');
			} catch (error) {
				console.error('Error setting min-width:', error);
			}
		});
		this.renderer.setStyle(datePickerInput, 'min-width', (modalWidth - 32).toString() + 'px');
		this.renderer.setStyle(cdsComboBox, 'min-width', (modalWidth - 32).toString() + 'px');
		this.cdr.detectChanges();
	}

	constructor(
		private http: HttpClient,
		private renderer: Renderer2,
		public syncService: SyncService,
		private cdr: ChangeDetectorRef,
		public httpService: HttpService
	) {}

	ngOnInit(): void {

		this.httpService.wakeUpServer();

		if (this.syncService.authStatus.getValue() !== 'authenticated') {
			this.syncService.updateAuthStatus('unauthenticated');
			this.syncService.updatePage('login');
			return;
		}

		this.syncService.fileData$.subscribe((data) => {
			this.currentFileData = data;
			this.fileReferenceDateObject = this.getReferenceDate(this.currentFileData['Reference Date'])
		});

		this.syncService.email$.subscribe((data) => {
			this.email = data;
			if (this.email.endsWith('industryventures.com')) {
				this.fileTypeItems = [
					{
						'content': 'Annual or Quarterly Report',
						'selected': false
					},
					{
						'content': 'Audit or Financial Statement',
						'selected': false
					},
					{
						'content': 'Capital Account Statement',
						'selected': false
					},
					{
						'content': 'Limited Partnership Agreement',
						'selected': false
					}
				]
			}
		});

		this.syncService.currentDeal$.subscribe((data) => {
			this.currentDeal = data;
		});

		this.subscription = this.syncService.userData$.subscribe((data) => {
			this.userData = data;
			console.log('this.userData', this.userData);
			this.deals = data['Deals'];
			this.displayFiles = [];
			this.deals.forEach((deal: any) => {
				if (this.currentDeal === '' || deal['Deal Name'] === this.currentDeal) {
					deal['Files'].forEach((file: any) => {
						file['Deal Name'] = deal['Deal Name'];
						this.displayFiles.push(file);
					});
				}
			});
			this.displayFiles = this.displayFiles.sort((a: any, b: any) => b['Timestamp'] - a['Timestamp']);
		});

		this.syncService.currentDeal$.subscribe((data) => {
			this.displayFiles = [];
			this.currentDeal = data;
			this.deals.forEach((deal: any) => {
				if (this.currentDeal === '' || deal['Deal Name'] === this.currentDeal) {
					deal['Files'].forEach((file: any) => {
						file['Deal Name'] = deal['Deal Name'];
						this.displayFiles.push(file);
					});
				}
			});
			this.displayFiles = this.displayFiles.sort((a: any, b: any) => b['Timestamp'] - a['Timestamp']);
		});
		this.cdr.detectChanges();
		this.setTargetMinWidth();
		window.addEventListener('resize', this.setTargetMinWidth.bind(this));
	}

	checkFileStatus(file:  any): string {
		return file['File Status'];
		// const fileTimestamp = new Date(file.Timestamp).getTime();
		// const currentTimestamp = Date.now();
		// const tenMinutesInMilliseconds = 60 * 1000 * 60;
		//
		// // @ts-ignore
		// if (file['File Status']) {
		// 	// @ts-ignore
		// 	if (file['File Status'] === 'active' || file['File Status'] === 'error') {
		// 		if (Math.abs(currentTimestamp - fileTimestamp) > tenMinutesInMilliseconds) {
		// 			return 'error';
		// 		}
		// 		// @ts-ignore
		// 		return file['File Status'];
		// 	}
		// 	// @ts-ignore
		// 	return file['File Status'];
		// } else {
		// 	if (Math.abs(currentTimestamp - fileTimestamp) > tenMinutesInMilliseconds) {
		// 		return 'error';
		// 	}
		// 	return 'active';
		// }
	}

	searchFiles($event: string) {
	  const searchString = $event;
	  const substrings = searchString.split(' ');

	  this.displayFiles = this.deals.map(
		(deal: any) => deal['Files']
	  ).flat().filter(
		(file: any) => substrings.every(substring => file['File Name'].toLowerCase().includes(substring.toLowerCase()))
	  ).sort((a: any, b: any) => b['Timestamp'] - a['Timestamp']);
	}

	enteringContainedListItem(key: any) {
		this.hoveringOverItem = key;
	}

	async onFileClick(event: any, file: any) {
		this.httpService.reloadUserData(false);
		if (!event) {
			return;
		}
		console.log('this.userData', this.userData);
		// this.showSpinner = true;
		this.syncService.updateShowSpinner(true);
		// this.sourcePage = -1;
		this.syncService.updateNotifyError(false);
		// this.fileDocRef = file['Files Document'];
		if (file['File Status'] === 'active') {
			this.syncService.updateShowSpinner(false);
			this.syncService.updateNotifyAnalyzing(true);
			setTimeout(() => {
				this.syncService.updateNotifyAnalyzing(false);
			}, 5000);
		} else if (file['File Status'] === 'error') {
			this.syncService.updateShowSpinner(false);
			if (file['Error']) {
				this.syncService.updateNotification('error', 'File Processing Error', file['Error']);
			} else {
				this.syncService.updateShowSpinner(false);
				this.syncService.updateNotifyError(true);
				this.syncService.updateNotifyAnalyzing(false);
				setTimeout(() => {
					this.syncService.updateNotifyError(false);
				}, 5000);
			}
		} else {
			if (!(event.target as HTMLElement).closest('.overflowMenu')) {
				const oldData = this.syncService.fileData.getValue();
				if (file['Files Document']) {
					// alert(file['Files Document'])
					this.syncService.updateFileId(file['Files Document']);
					try {
						let attempts = 0;
						const maxAttempts = 10;
						while (oldData === this.syncService.fileData.getValue() && attempts < maxAttempts) {
						  await new Promise(resolve => setTimeout(resolve, 100));
						  attempts++;
						}
						this.syncService.updateShowSpinner(false);
						if (file['File Name'].endsWith(' Compiled')) {
							this.syncService.updatePage('fund-data');
						} else {
							this.syncService.updatePage('file-data');
						}
					} catch (error) {
						// this.loadingFile = false;
						this.syncService.updateNotifyError(true);
						setTimeout(() => {
							this.syncService.updateNotifyError(false);
							this.syncService.updateShowSpinner(false);
						}, 5000);
					}
				} else {
					this.httpService.reloadUserData(false);
					this.syncService.updateShowSpinner(false);
				}
			}
		}
	}

	confirmFileDeletion(fileObject: any) {
		console.log('confirmFileDeletion', fileObject);
		this.syncService.updateFilePendingDeletion(fileObject);
		this.syncService.updateFileDeletionModalOpen(true);
	}

	compileData() {
		let currentDealData = null
		let compiledFileExists = false
		for (let i = 0; i < this.userData['Deals'].length; i++) {
			// @ts-ignore
			if (this.userData['Deals'][i]['Deal Name'] === this.currentDeal) {
				currentDealData = this.userData['Deals'][i];
				for (let j=0; j < this.userData['Deals'][i]['Files'].length; j++) {
					if (this.userData['Deals'][i]['Files'][j]['File Name'] === this.currentDeal + ' Compiled') {
						compiledFileExists = true
						this.userData['Deals'][i]['Files'][j]['File Status'] = 'active'
					}
				}
			}
		}

		if (compiledFileExists) {
		} else {
			const newFile = {
				'File Name': this.currentDeal + ' Compiled',
				'File Status': 'active',
				'File Types': '',
				'Timestamp': new Date().getTime().toString(),
				// @ts-ignore
				'Deal Name': this.currentDeal,
				// @ts-ignore
				'Reference Date': '',
			};
			for (let i = 0; i < this.userData['Deals'].length; i++) {
				// @ts-ignore
				if (this.userData['Deals'][i]['Deal Name'] === this.currentDeal) {
					this.userData['Deals'][i]['Files'].unshift(newFile);
					this.syncService.updateUserData(this.userData); // PROCESS FILE
				}
			}
		}

		// this.syncService.updateNotificationType('success');
		// this.syncService.updateNotificationTitle('We\'ll start pricing ' + this.currentDeal + ' shortly.');
		// this.syncService.updateNotificationSubtitle('We\'ll notify you once the process is complete.');
		// this.syncService.updateShowNotification(true);
		// const formData: FormData = new FormData();
		// formData.append('Email', this.userData['Email']); // DONE
		// formData.append('Deal Name', this.currentDeal);
		// const headers = new HttpHeaders();
		// this.http.post(this.validateUrl, formData, { headers }).subscribe();
		// setTimeout(() => {
		// 	this.syncService.updateShowNotification(false);
		// }, 5000);

		this.httpService.aggregate(currentDealData)
	}

	exportExcel(actionData: any) {
		// console.log(actionData);
		this.syncService.updateShowSpinner(true);
		const formData: FormData = new FormData();
		// @ts-ignore
		formData.append('Files Document', actionData['Files Document']);
		const headers = new HttpHeaders();
		headers.append('Content-Type', 'multipart/form-data');
		this.http.post(this.exportUrl, formData, { headers, responseType: 'blob' })
			.subscribe((response: any) => {
				saveAs(response, actionData['File Name'] + '.csv');
				this.syncService.updateShowSpinner(false);
			},
			(error: any) => {
				console.error('Error occurred while rendering the page:', error);
				this.syncService.updateShowSpinner(false);
			});
	}

	closeModal() {
		this.editFileModalOpen = false;
	}

	onSaveFileClick() {
		if (this.fileName === '') {
			this.fileNameInvalid = true;
			this.fileNameInvalidText = 'File name is required';
			return;
		}
		this.userData['Deals'].forEach((deal: any) => {
			if (deal['Deal Name'] === this.currentDeal) {
				deal['Files'].forEach((file: any) => {
					if (file['Files Document'] === this.currentFileData['Files Document']) {
						file['File Name'] = this.fileName;
						file['Reference Date'] = this.fileReferenceDate;
						file['File Types'] = this.currentFileData['File Types'];
						this.syncService.updateUserData(this.userData); // ON SAVE FILE CLICK
					}
				});
			}
		});
		this.editFileModalOpen = false;
	}

	onSelectReferenceDate($event: any) {
		const date = new Date($event[0]);
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		this.fileReferenceDate = `${year}-${month}-${day}`;
		this.fileReferenceDateObject = [date];
	}

	openEditFileModal(actionData: any) {
		this.cdr.detectChanges();
		this.setTargetMinWidth();
		window.addEventListener('resize', this.setTargetMinWidth.bind(this));
		this.editFileModalOpen = true;
		this.currentFileData = actionData;
		this.fileName = this.currentFileData['File Name'];
		this.fileReferenceDate = this.currentFileData['Reference Date'];
		this.fileReferenceDateObject = this.getReferenceDate(this.currentFileData['Reference Date']);
		console.log('this.currentFileData', this.currentFileData);
		this.currentFileTypes = this.fileTypeItems.map(item => {
			if (actionData['File Types'].includes(item.content)) {
				return { ...item, selected: true };
			}
			return item;
		});
	}

	onSelectFileTypes($event: ListItem | ListItem[]) {
		const selectedFileTypes = ($event as ListItem[]).filter(item => item.selected).map(item => item.content);
		this.currentFileData['File Types'] = selectedFileTypes.join('|');
	}

	onKeyUpFileName($event: KeyboardEvent) {
		this.fileName = ($event.target as HTMLInputElement).value;
		this.currentFileData['File Name'] = ($event.target as HTMLInputElement).value;
	}

	extractData(actionDatum: any) {
		const timestamp = new Date().getTime().toString();
		console.log('actionDatum', actionDatum);
		this.userData['Deals'].forEach((deal: any) => {
			if (deal['Deal Name'] === actionDatum['Deal Name']) {
				deal['Files'].forEach((file: any) => {
					if (file['File Name'] === actionDatum['File Name'] && file['Timestamp'] === actionDatum['Timestamp']) {
						file['File Status'] = 'active';
						file['Timestamp'] = timestamp;
						this.syncService.updateUserData(this.userData); // EXTRACT DATA
					}
				});
			}
		});
		this.httpService.reprocessFile(actionDatum, timestamp);
	}

	getReferenceDate(dateString: any): (Date | string)[] {
		try {
			this.fileReferenceDate = dateString;
			const [year, month, day] = dateString.split('-').map(Number);
			return [new Date(year, month - 1, day)];
		} catch {
			return [];
		}
		// const [year, month, day] = dateString.split('-').map(Number);
		// return [new Date(year, month - 1, day)];
	  // return [new Date(dateString)];
	}

	downloadFile(actionDatum: any) {
		this.httpService.downloadFile(actionDatum['File Name'], actionDatum['Files Document']);
	}

	ngOnDestroy() {
		this.subscription?.unsubscribe();
	}
}
